// Package Imports
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.css']
})
export class SsoLoginComponent implements OnInit {
  constructor(private readonly router: Router,
              private readonly sessionService: SessionService) { }

  ngOnInit() {
    const keepAliveReq = this.sessionService.getSessionData(this.sessionService.sessionKey_KeepSessionAlive);

    if (keepAliveReq) {
      this.router.navigate([`/keepsessionalive`]);
    }
    else {
      this.router.navigate([`/home`]);
    }
  }
}
